module.exports = __webpack_public_path__ + "static/material-badge-visibility-fcdfb886f6655aefb720cfa4eaec7d67.gif";